export const CREDIT_QUALITY_SCORE_TITLE = 'Credit Quality Score (CQS)';
export const FALLEN_ANGEL_SCORE_TITLE = 'Fallen Angel Score (FAS)';
export const AGENCY_COMPOSITE_RATING_TITLE = 'Agency Composite Rating (ACR)';
export const CREDIT_RISK_ESTIMATE_TITLE = 'Credit Risk Estimate (CRE)';
export const ANALYST_RECOMMENDATION_TITLE = 'Analyst Recommendation';
export const CURRENT_SCORE = 'Current Score';
export const CQD = 'Credit Quality Differential (CQD)';
export const PREVIOUS = 'Previous';
export const Y3_PERIOD = '3 Year Period';
export const Y5_PERIOD = '5 Year Period';
export const CRL = 'Credit Risk Level (CRL)';
export const CALCULATION_DATE = 'Calculation Date:';
export const FUNDAMENTAL_DATE = 'Fundamental Date:';
export const MODEL = 'Model:';
export const NOTES = 'Notes:';
